import { render, staticRenderFns } from "./ApproveAppointment.vue?vue&type=template&id=a5886cfe&scoped=true"
import script from "./ApproveAppointment.vue?vue&type=script&lang=js"
export * from "./ApproveAppointment.vue?vue&type=script&lang=js"
import style0 from "./ApproveAppointment.vue?vue&type=style&index=0&id=a5886cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5886cfe",
  null
  
)

export default component.exports